import $lhGmr$intlspinbuttonarAEmjs from "../intl/spinbutton/ar-AE.mjs";
import $lhGmr$intlspinbuttonbgBGmjs from "../intl/spinbutton/bg-BG.mjs";
import $lhGmr$intlspinbuttoncsCZmjs from "../intl/spinbutton/cs-CZ.mjs";
import $lhGmr$intlspinbuttondaDKmjs from "../intl/spinbutton/da-DK.mjs";
import $lhGmr$intlspinbuttondeDEmjs from "../intl/spinbutton/de-DE.mjs";
import $lhGmr$intlspinbuttonelGRmjs from "../intl/spinbutton/el-GR.mjs";
import $lhGmr$intlspinbuttonenUSmjs from "../intl/spinbutton/en-US.mjs";
import $lhGmr$intlspinbuttonesESmjs from "../intl/spinbutton/es-ES.mjs";
import $lhGmr$intlspinbuttonetEEmjs from "../intl/spinbutton/et-EE.mjs";
import $lhGmr$intlspinbuttonfiFImjs from "../intl/spinbutton/fi-FI.mjs";
import $lhGmr$intlspinbuttonfrFRmjs from "../intl/spinbutton/fr-FR.mjs";
import $lhGmr$intlspinbuttonheILmjs from "../intl/spinbutton/he-IL.mjs";
import $lhGmr$intlspinbuttonhrHRmjs from "../intl/spinbutton/hr-HR.mjs";
import $lhGmr$intlspinbuttonhuHUmjs from "../intl/spinbutton/hu-HU.mjs";
import $lhGmr$intlspinbuttonitITmjs from "../intl/spinbutton/it-IT.mjs";
import $lhGmr$intlspinbuttonjaJPmjs from "../intl/spinbutton/ja-JP.mjs";
import $lhGmr$intlspinbuttonkoKRmjs from "../intl/spinbutton/ko-KR.mjs";
import $lhGmr$intlspinbuttonltLTmjs from "../intl/spinbutton/lt-LT.mjs";
import $lhGmr$intlspinbuttonlvLVmjs from "../intl/spinbutton/lv-LV.mjs";
import $lhGmr$intlspinbuttonnbNOmjs from "../intl/spinbutton/nb-NO.mjs";
import $lhGmr$intlspinbuttonnlNLmjs from "../intl/spinbutton/nl-NL.mjs";
import $lhGmr$intlspinbuttonplPLmjs from "../intl/spinbutton/pl-PL.mjs";
import $lhGmr$intlspinbuttonptBRmjs from "../intl/spinbutton/pt-BR.mjs";
import $lhGmr$intlspinbuttonptPTmjs from "../intl/spinbutton/pt-PT.mjs";
import $lhGmr$intlspinbuttonroROmjs from "../intl/spinbutton/ro-RO.mjs";
import $lhGmr$intlspinbuttonruRUmjs from "../intl/spinbutton/ru-RU.mjs";
import $lhGmr$intlspinbuttonskSKmjs from "../intl/spinbutton/sk-SK.mjs";
import $lhGmr$intlspinbuttonslSImjs from "../intl/spinbutton/sl-SI.mjs";
import $lhGmr$intlspinbuttonsrSPmjs from "../intl/spinbutton/sr-SP.mjs";
import $lhGmr$intlspinbuttonsvSEmjs from "../intl/spinbutton/sv-SE.mjs";
import $lhGmr$intlspinbuttontrTRmjs from "../intl/spinbutton/tr-TR.mjs";
import $lhGmr$intlspinbuttonukUAmjs from "../intl/spinbutton/uk-UA.mjs";
import $lhGmr$intlspinbuttonzhCNmjs from "../intl/spinbutton/zh-CN.mjs";
import $lhGmr$intlspinbuttonzhTWmjs from "../intl/spinbutton/zh-TW.mjs";

var $6279e3628ec747df$exports = {};


































$6279e3628ec747df$exports = {
    "ar-AE": $lhGmr$intlspinbuttonarAEmjs,
    "bg-BG": $lhGmr$intlspinbuttonbgBGmjs,
    "cs-CZ": $lhGmr$intlspinbuttoncsCZmjs,
    "da-DK": $lhGmr$intlspinbuttondaDKmjs,
    "de-DE": $lhGmr$intlspinbuttondeDEmjs,
    "el-GR": $lhGmr$intlspinbuttonelGRmjs,
    "en-US": $lhGmr$intlspinbuttonenUSmjs,
    "es-ES": $lhGmr$intlspinbuttonesESmjs,
    "et-EE": $lhGmr$intlspinbuttonetEEmjs,
    "fi-FI": $lhGmr$intlspinbuttonfiFImjs,
    "fr-FR": $lhGmr$intlspinbuttonfrFRmjs,
    "he-IL": $lhGmr$intlspinbuttonheILmjs,
    "hr-HR": $lhGmr$intlspinbuttonhrHRmjs,
    "hu-HU": $lhGmr$intlspinbuttonhuHUmjs,
    "it-IT": $lhGmr$intlspinbuttonitITmjs,
    "ja-JP": $lhGmr$intlspinbuttonjaJPmjs,
    "ko-KR": $lhGmr$intlspinbuttonkoKRmjs,
    "lt-LT": $lhGmr$intlspinbuttonltLTmjs,
    "lv-LV": $lhGmr$intlspinbuttonlvLVmjs,
    "nb-NO": $lhGmr$intlspinbuttonnbNOmjs,
    "nl-NL": $lhGmr$intlspinbuttonnlNLmjs,
    "pl-PL": $lhGmr$intlspinbuttonplPLmjs,
    "pt-BR": $lhGmr$intlspinbuttonptBRmjs,
    "pt-PT": $lhGmr$intlspinbuttonptPTmjs,
    "ro-RO": $lhGmr$intlspinbuttonroROmjs,
    "ru-RU": $lhGmr$intlspinbuttonruRUmjs,
    "sk-SK": $lhGmr$intlspinbuttonskSKmjs,
    "sl-SI": $lhGmr$intlspinbuttonslSImjs,
    "sr-SP": $lhGmr$intlspinbuttonsrSPmjs,
    "sv-SE": $lhGmr$intlspinbuttonsvSEmjs,
    "tr-TR": $lhGmr$intlspinbuttontrTRmjs,
    "uk-UA": $lhGmr$intlspinbuttonukUAmjs,
    "zh-CN": $lhGmr$intlspinbuttonzhCNmjs,
    "zh-TW": $lhGmr$intlspinbuttonzhTWmjs
};


export {$6279e3628ec747df$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
